const COUNTER_SUFFIX = /\s*\((\d+)\)$/

/**
 * Builds a unique duplicate name: "{prefix} {name}" or "{prefix} {name} (n)".
 * Empty/whitespace names use `untitledFallback`. Strips one existing copy prefix
 * and any "(n)" suffix so prefixes do not stack. `prefix` may include a trailing space.
 */
export function buildCopyName(
  prefix: string,
  originalName: string | null | undefined,
  untitledFallback: string,
  existingNames: readonly string[] = []
): string {
  const copyPrefix = prefix.trim()
  const trimmed = originalName?.trim() ?? ''
  let core = trimmed || untitledFallback

  const normalizedPrefix = `${copyPrefix.toLowerCase()} `
  if (core.toLowerCase().startsWith(normalizedPrefix)) {
    core = core.slice(copyPrefix.length).trim()
  }
  core = core.replace(COUNTER_SUFFIX, '').trim() || untitledFallback

  const candidate = `${copyPrefix} ${core}`
  const taken = new Set<string>()
  for (const name of existingNames) {
    const value = name?.trim()
    if (value) taken.add(value)
  }
  if (trimmed) taken.add(trimmed)

  if (!taken.has(candidate)) return candidate

  let counter = 1
  while (taken.has(`${candidate} (${counter})`)) counter++
  return `${candidate} (${counter})`
}
